import { useState } from '@adornis/functional-lit/stateful.js';
import { toggleEditorGeometryLock } from '../../geometry.js';

export interface EditorGeometryOverlayRect {
  elementId: string;
  left: number;
  top: number;
  width: number;
  height: number;
}

export const useEditorGeometryState = () => {
  const [unlockedElementIds, setUnlockedElementIds] = useState<ReadonlySet<string>>(new Set<string>(), []);
  const [overlayRect, setOverlayRect] = useState<EditorGeometryOverlayRect | null>(null, []);
  const [focusEditingElementId, setFocusEditingElementId] = useState<string | null>(null, []);
  const [imageEditingMode, setImageEditingMode] = useState<'image' | 'mask'>('mask', []);

  const isUnlocked = (elementId: string) => unlockedElementIds.has(elementId);
  const toggleLock = (elementId: string) => setUnlockedElementIds(toggleEditorGeometryLock(unlockedElementIds, elementId));
  const lockAll = () => {
    setUnlockedElementIds(new Set<string>());
    setFocusEditingElementId(null);
    setImageEditingMode('image');
  };

  return {
    unlockedElementIds,
    overlayRect,
    focusEditingElementId,
    imageEditingMode,
    isUnlocked,
    toggleLock,
    lockAll,
    setOverlayRect,
    setFocusEditingElementId,
    setImageEditingMode,
  };
};

export type EditorGeometryState = ReturnType<typeof useEditorGeometryState>;
